const AGRICHILE_RESTRICTED_TENANTS = [
  'santa-anita-test',
  'san-sebastian-test',
  'san-gregorio-test',
  'caracas-test',
  'tcit',
];

const RESTRICTED_OPERATOR_ROLES = ['operator', 'production', 'production_operator'];

const RESTRICTED_ALLOWED_MODULES = [
  'HOME',
  'RECEIPTS',
  'PROCESSES',
  'PROCESS',
  'DISPATCHES',
  'PROCESS_TYPES',
];

const RESTRICTED_ALLOWED_MAINTAINERS = ['PROCESS_TYPES'];

export const getCurrentSubdomain = () => window.location.hostname.split('.')[0];

export const isAgrichileRestrictedTenant = (subdomain = '') =>
  AGRICHILE_RESTRICTED_TENANTS.includes(subdomain);

export const isRestrictedOperatorRole = (roleName = '') =>
  RESTRICTED_OPERATOR_ROLES.includes(roleName);

export const getAccessPolicy = ({ subdomain, roleName }) => {
  const isRestrictedOperator =
    isAgrichileRestrictedTenant(subdomain) && isRestrictedOperatorRole(roleName);

  if (!isRestrictedOperator) {
    return {
      restricted: false,
      allowedModules: null,
      allowedMaintainers: null,
      receipts: {
        canCreate: true,
        canEdit: true,
        canDelete: true,
        canPrint: true,
        canTraceability: true,
        canExport: true,
      },
      processes: {
        canCreate: true,
        canEdit: true,
        canDelete: true,
        canExport: true,
        canImportEmployeeCosts: true,
        canViewDetail: true,
        canScan: true,
        canReprocess: true,
      },
      dispatches: {
        canCreate: true,
        canEdit: true,
        canDelete: true,
        canPrint: true,
        canExport: true,
        canViewDetail: true,
      },
      processTypes: {
        canCreate: true,
        canEdit: true,
        canDelete: true,
        canBulkEditLoss: true,
        canExport: true,
        automationActions: ['receipt', 'dispatch'],
      },
    };
  }

  return {
    restricted: true,
    allowedModules: RESTRICTED_ALLOWED_MODULES,
    allowedMaintainers: RESTRICTED_ALLOWED_MAINTAINERS,
    receipts: {
      canCreate: false,
      canEdit: true,
      canDelete: false,
      canPrint: true,
      canTraceability: true,
      canExport: false,
    },
    processes: {
      canCreate: false,
      canEdit: false,
      canDelete: false,
      canExport: false,
      canImportEmployeeCosts: false,
      canViewDetail: true,
      canScan: true,
      canReprocess: true,
    },
    dispatches: {
      canCreate: false,
      canEdit: false,
      canDelete: false,
      canPrint: false,
      canExport: false,
      canViewDetail: false,
    },
    processTypes: {
      canCreate: false,
      canEdit: false,
      canDelete: false,
      canBulkEditLoss: false,
      canExport: false,
      automationActions: ['receipt'],
    },
  };
};

export const canAccessModule = (module, accessPolicy) =>
  !accessPolicy?.allowedModules || accessPolicy.allowedModules.includes(module);

export const canAccessMaintainer = (module, accessPolicy) =>
  !accessPolicy?.allowedMaintainers || accessPolicy.allowedMaintainers.includes(module);
